import Swiper from "swiper";

export default class ColumnSlider {
  constructor(selector = ".c-column-slider__slider") {
    const el = document.querySelector(selector);
    if (!el) return;

    const swiper = new Swiper(el, {
      slidesPerView: 1.25,
      spaceBetween: 20,
      breakpoints: {
        768: {
          spaceBetween: 24,
          slidesPerView: 3.8,
        },
      },
    });

    const section = el.closest(".c-column-slider");
    const prevBtns = section?.querySelectorAll(".c-column-slider__nav-btn.-prev") ?? [];
    const nextBtns = section?.querySelectorAll(".c-column-slider__nav-btn.-next") ?? [];

    prevBtns.forEach((btn) => btn.addEventListener("click", () => swiper.slidePrev()));
    nextBtns.forEach((btn) => btn.addEventListener("click", () => swiper.slideNext()));

    // 端に到達したら該当ボタンを disabled にして、CSS 側で薄く表示する
    const updateNavState = () => {
      prevBtns.forEach((btn) => (btn.disabled = swiper.isBeginning));
      nextBtns.forEach((btn) => (btn.disabled = swiper.isEnd));
    };

    // toEdge / fromEdge は端に着いた・端から離れた瞬間に発火する（Swiper の Navigation モジュールと同じ購読）
    swiper.on("toEdge fromEdge lock unlock resize update observerUpdate", updateNavState);
    updateNavState();
  }
}
